module.exports = __webpack_public_path__ + "static/img/news52.a7ce22f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news52.gif
// module id = vTx8
// module chunks = 0